type DBStatus = 'in_asteptare' | 'in_incarcare' | 'pe_drum' | 'livrat';

// Utility Functions
export const getStatusDisplayText = (dbStatus: DBStatus): string => {
  switch (dbStatus) {
    case 'in_asteptare': return 'În așteptare';
    case 'in_incarcare': return 'În încărcare';
    case 'pe_drum': return 'Pe drum';
    case 'livrat': return 'Livrat';
    default: return 'Necunoscut';
  }
};

export const getStatusButtonText = (currentDBStatus: DBStatus): string => {
  switch (currentDBStatus) {
    case 'in_asteptare': return 'Începe încărcarea';
    case 'in_incarcare': return 'Pornește spre destinație';
    case 'pe_drum': return 'Marchează livrat';
    case 'livrat': return 'Completat';
    default: return 'Actualizează';
  }
};

export const getNextDBStatus = (currentDBStatus: DBStatus): DBStatus | null => {
  switch (currentDBStatus) {
    case 'in_asteptare': return 'in_incarcare';
    case 'in_incarcare': return 'pe_drum';
    case 'pe_drum': return 'livrat';
    case 'livrat': return null;
    default: return null;
  }
};

export const getStatusColor = (dbStatus: DBStatus): string => {
  switch (dbStatus) {
    case 'in_asteptare': return 'bg-blue-500/20 text-blue-300 border-blue-400/40';
    case 'in_incarcare': return 'bg-orange-500/20 text-orange-300 border-orange-400/40';
    case 'pe_drum': return 'bg-yellow-500/20 text-yellow-300 border-yellow-400/40';
    case 'livrat': return 'bg-green-500/20 text-green-300 border-green-400/40';
    default: return 'bg-gray-500/20 text-gray-300 border-gray-400/40';
  }
};
